@if(!showCards){

<div class="main-container">

    <!-- TITLE -->

    <div class="title">
        <span class="title-text">Manual Update</span>

        <p class="small-title">
            Enter family code to proceed with the search.
        </p>
        <p class="small-title" style="color: #f28b82 !important; margin-top: -8px;">
            I, {{ name }}, am solely responsible for the changes made here.
        </p>
    </div>

    <!-- SEARCH FORM -->

    <form [formGroup]="searchForm" (ngSubmit)="searchByFamilyCode()">

        <div class="searchBar">

            <input type="text" maxlength="12" class="searchInput ac-input-control" placeholder="Enter family code"
                formControlName="familyCode" />

            <div class="btn">

                <button type="button" class="ac-secondary-btn" (click)="reset()">
                    Reset
                </button>

                <button type="submit" class="ac-primary-btn" [disabled]="searchForm.invalid">
                    Search
                </button>

            </div>

        </div>

    </form>

    <!-- SEARCH RESULTS -->

    @if(profileList.length > 0){

    <!-- DESKTOP TABLE -->

    @if(!isMobile){

    <div class="table-container">

        <table class="table">

            <thead class="table-head">
                <tr>
                    <th>Name</th>
                    <th>Gender</th>
                    <th>Family Code</th>
                    <th>Mobile Number</th>
                    <th>Aadhaar Number</th>
                    <th>Status</th>
                </tr>
            </thead>

            <tbody class="table-body">

                @for(row of profileList; track row){

                <tr (click)="onRowClick(row)">

                    <td>
                        {{row.devoteeFirstName}}
                        {{row.devoteeMiddleName || ''}}
                        {{row.devoteeLastName}}
                    </td>

                    <td>{{row.gender}}</td>

                    <td>{{row.devoteeFamilyCode}}</td>

                    <td>{{row.mobileNumber}}</td>

                    <td>{{row.idNumber}}</td>

                    <td>{{row.status}}</td>

                </tr>

                }

            </tbody>

        </table>

    </div>

    }

    <!-- MOBILE CARD LIST -->

    @if(isMobile){

    <div class="mobile-card-list">

        @for(row of profileList; track row){

        <div class="mobile-card" (click)="onRowClick(row)">

            <div class="mc-name">
                {{row.devoteeFirstName}}
                {{row.devoteeMiddleName || ''}}
                {{row.devoteeLastName}}
            </div>

            <div class="mc-row">
                <span class="mc-label">Gender</span>
                <span class="mc-value">{{row.gender}}</span>
            </div>

            <div class="mc-row">
                <span class="mc-label">Family Code</span>
                <span class="mc-value">{{row.devoteeFamilyCode}}</span>
            </div>

            <div class="mc-row">
                <span class="mc-label">Mobile</span>
                <span class="mc-value">{{row.mobileNumber}}</span>
            </div>

            <div class="mc-row">
                <span class="mc-label">Aadhaar</span>
                <span class="mc-value">{{row.idNumber}}</span>
            </div>

            <div class="mc-row">
                <span class="mc-label">Status</span>
                <span class="mc-value">{{row.status}}</span>
            </div>

        </div>

        }

    </div>

    }

    }

    <!-- EMPTY STATE -->

    @else {

    <div class="list-div">

        <div class="img-div">

            <img style="width: 150px;" src="icons/search_placeholder_dark.png" alt="No Data Found" />

            <span class="drop-title">
                No Data Found
            </span>

        </div>

    </div>

    }

</div>

}

<!-- DETAILS PAGE -->

@else {

<div class="main-container">

    <!-- HEADER -->

    <div class="title">

        <span class="back-btn" style="color: var(--brand-primary); cursor:pointer" (click)="back()">
            <img src="icons/back-arrow-icon.svg" style="height: 15px; width: 15px;" />

            Go back
        </span>

        <span class="title-text">

            {{ primaryMemberName }}
            -
            {{ primaryFC }}

        </span>
        <p style="
    color: #f28b82;
    font-size: 19px;
    margin-top: 6px;
    font-weight: 500;
  ">
            Note: Please verify all details carefully before making any changes. You will be solely responsible for the
            updates made here.
        </p>

    </div>

    <!-- PROFILE CARDS -->

    <div class="card-details">

        @for(item of profileDetails; track item){

        <div class="family-details">

            <!-- TOP NAME + TOGGLE -->

            <div class="details">

                <div class="name-row">

                    @if(item.isPrimaryDevotee){
                    <div class="primary-devotee">
                        <span class="common-text">
                            {{ item.devoteeFirstName }} {{ item.devoteeLastName }}


                            @if(item.workerType){
                            <span class="worker-type">({{ item.workerType }})</span>
                            }
                        </span>


                        <img src="icons/verified-badge-line.png" style="width: 20px; height: 20px;" alt="badge-img">


                        @if(!isMobile){
                        <div class="pending-design">
                            <span class="pending">Primary Devotee</span>
                        </div>
                        }

                    </div>
                    }
                    @else {
                    <span class="common-text">
                        {{ item.devoteeFirstName }} {{ item.devoteeLastName }}
                        @if(item.workerType){
                        <span class="worker-type">({{ item.workerType }})</span>
                        }
                    </span>
                    }

                    <!-- STATUS TOGGLE -->

                    @if(!item.isPrimaryDevotee){

                    <div class="toggle-group">

                        <div class="toggle-div" [class.active-div]="item.status === 'ACTIVE'"
                            (click)="updateStatus(item, 'ACTIVE')">
                            <span>Active</span>
                        </div>

                        <div class="toggle-div" [class.active-div]="item.status === 'INACTIVE'"
                            (click)="updateStatus(item, 'INACTIVE')">
                            <span>Inactive</span>
                        </div>

                    </div>

                    }
                </div>

            </div>

            <!-- NAME -->

            <div class="details">

                <span class="common-header">Name</span>

                <span class="common-text">
                    {{ item.devoteeFirstName }}
                    {{ item.devoteeMiddleName || '' }}
                    {{ item.devoteeLastName }}
                    <img src="icons/edit-line.png" class="edit-icon" (click)="editName(item)" />
                </span>

            </div>

            <!-- MEMBER CODE -->

            <div class="details">

                <span class="common-header">Member Code</span>

                <span class="common-text">
                    {{ item.devoteeMemberCode }}
                </span>

            </div>

            <!-- GENDER -->

            <div class="details">

                <span class="common-header">Gender</span>

                <span class="common-text">
                    {{ item.gender }}
                </span>

            </div>

            <!-- DOB -->

            <div class="details">

                <span class="common-header">Date Of Birth</span>

                <span class="common-text">
                    {{ item.dateOfBirth }}
                </span>

            </div>

            <!-- MOBILE -->

            <div class="details">

                <span class="common-header">Mobile</span>

                <span class="common-text">
                    {{ item.mobileNumber }}
                    <img src="icons/edit-line.png" class="edit-icon" (click)="editPhone(item)" />
                    <button class="icon-btn delete-btn" (click)="deletePhone(item)" title="Delete">
                        <img src="icons/delete-bin.png" class="action-icon" alt="delete" />
                    </button>
                
                </span>

            </div>

            <!-- AADHAAR -->

            <div class="details">

                <span class="common-header">Aadhaar Number</span>

                <span class="common-text">
                    {{ item.idNumber }}
                    <img src="icons/edit-line.png" class="edit-icon" (click)="editAdhar(item)" />

                </span>

            </div>

            <!-- RELATIONSHIP -->

            <div class="details">

                <span class="common-header">Relationship</span>

                <span class="common-text">
                    {{ item.relationshipWithPrimaryDevotee }}
                </span>

            </div>

            <!-- NATIONALITY -->

            <div class="details">

                <span class="common-header">Nationality</span>

                <span class="common-text">
                    {{ item.nationality }}
                </span>

            </div>

            <!-- STATUS -->

            <div class="details">
                <span class="common-header">Status</span>
                <span class="common-text">
                    {{ item.status }}
                </span>
            </div>
        </div>

        }

    </div>

</div>

}